<template>
    <v-row dense >
      <v-col
          v-for="category in getItemsCategories"
          :key="category.id"
          cols="12" :md="md"
      >
        <v-list class="py-0" >
          <v-list-item>
            <v-list-item-title class="font-weight-bold title">
              {{ category.name }}
            </v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>

          <v-list-item v-for="item in getItemsByCategory(category)"
                       :key="item.product.id">
            <v-list-item-avatar >
              <v-img eager  :src="getImage(item,category)" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.product.name }}
              </v-list-item-title>
              <v-list-item-subtitle>
                ${{ getPrice(item.product,category) }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar>
              <v-chip class="grey--text text--darken-4 grey lighten-3">
                <span>{{ item.quantity }}</span>
              </v-chip>
            </v-list-item-avatar>

          </v-list-item>

          <!--SUBTOTAL-->
          <v-list-item>

            <v-list-item-content>
              <v-list-item-title
                  class="subtitle-1 text-right"
                  :style="{color: category.fontColor ? category.fontColor : null }">
                <b>Total {{ category.name }}</b>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-avatar>
              <v-chip
                  class="font-weight-bold"
                  :style="{backgroundColor: category.backgroundColor, color: category.fontColor}"
              >
                {{ categoryItemsQuantity(category) }}
              </v-chip>
            </v-list-item-avatar>
          </v-list-item>

        </v-list>
      </v-col>
    </v-row>
</template>

<script>
import CategoryMixin from "@/modules/delivery/mixins/CategoryMixin";
import ProductMixin from "@/modules/delivery/mixins/ProductMixin";

export default {
  name: "OrderItems",
  props: {
    items: {type: Array},
    sm: {type: String, default: '12'},
    md: {type: String, default: '12'},
    lg: {type: String, default: '12'},
  },
  mixins: [CategoryMixin,ProductMixin],
  computed:{
    getImage() {
      return (item, category) => {
        let imageCategory
        if (item.product.imageCategory) {
          imageCategory = item.product.imageCategory.find(i => i.category === category.id)
        }
        return (imageCategory && imageCategory.image) ? imageCategory.image : item.product.image

      }

    },
    categoryItemsQuantity() {
      return category => {
        return this.items.reduce((a, i) => {
          if (category.id === i.category.id) {
            return a + i.quantity
          }
          return a
        }, 0)
      }
    }
  }
}
</script>

<style scoped>

</style>
